var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 -4.45521e-07 18.6274 -4.45521e-07 12C-4.45521e-07 5.37256 5.37258 -2.62988e-05 12 -2.62988e-05C18.6274 -2.62988e-05 24 5.37256 24 12Z",
    fill: "#4909AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 6.64706L12.624 5.45294C12.488 5.17294 12.208 5 11.904 5H6.8C6.36 5 6 5.37059 6 5.82353V18.1765C6 18.6294 6.36 19 6.8 19C7.24 19 7.6 18.6294 7.6 18.1765V13.2353H11.6L12.176 14.4294C12.312 14.7094 12.592 14.8824 12.888 14.8824H17.2C17.64 14.8824 18 14.5118 18 14.0588V7.47059C18 7.01765 17.64 6.64706 17.2 6.64706H13.2ZM16.4 13.2353H13.2L12.4 11.5882H7.6V6.64706H11.6L12.4 8.29412H16.4V13.2353Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.ed4adf4c64ee9bbc2fd8a75703edd8d2.svg";
export { ForwardRef as ReactComponent };